/**
 * Copyright (C) Sitevision 2002-2023, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-comments2-portlet')) {
  import(/* webpackChunkName: "comments2-plugins" */ './plugins-slim');
}
